import { PageWidgetType } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import {
  type PageWidgetQuiz,
  type PageWidgetQuizLike,
} from '@efdigital/ll-addon-data/types/content/objects/page-widget-quiz';
import { selectValue } from '@efdigital/ll-addon-ui/modifiers/select-value';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import type {
  PageWidgetComponentSignature,
  WidgetEditor,
} from '../page-widget-signature.ts';

type QuizItemDisplayType = PageWidgetQuiz['itemDisplay'];

const QUIZ_ITEM_DISPLAY_TYPES: Record<QuizItemDisplayType, string> = {
  embed: 'Embed',
} as const;

const QUIZ_ITEM_DISPLAY_TYPES_ARRAY = Object.entries(
  QUIZ_ITEM_DISPLAY_TYPES
).map(([key, value]) => ({
  key,
  value,
}));

export class PageWidgetQuizComponent extends Component<PageWidgetComponentSignature> {
  get widget() {
    return this.args.widget as PageWidgetQuiz;
  }

  setShowItemTitles = (event: Event) => {
    const showTitle = (event.target as HTMLInputElement).checked;
    this.widget.showItemTitle = showTitle;
  };

  setItemDisplay = (event: Event) => {
    const itemDisplay = (event.target as HTMLSelectElement)
      .value as PageWidgetQuiz['itemDisplay'];
    this.widget.itemDisplay = itemDisplay;
  };

  setQuizId = (event: Event) => {
    const quizId = (event.target as HTMLInputElement).value;
    this.widget.quizId = quizId;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-quizId">Quiz</label>
          <input
            class="form-control"
            id="{{uniqueId}}-quizId"
            type="text"
            value={{this.widget.quizId}}
            {{on "change" this.setQuizId}}
          />
        </div>

        <div class="form-group mb-4">
          <label for="{{uniqueId}}-itemDisplay">Display</label>
          <select
            class="form-control"
            id="{{uniqueId}}-itemDisplay"
            {{selectValue this.widget.itemDisplay}}
            {{on "change" this.setItemDisplay}}
          >
            {{#each QUIZ_ITEM_DISPLAY_TYPES_ARRAY as |itemDisplay|}}
              <option value={{itemDisplay.key}}>{{itemDisplay.value}}</option>
            {{/each}}
          </select>
        </div>
      </div>
    {{/let}}
  </template>
}

const DEFAULT_WIDGET_QUIZ: Omit<PageWidgetQuizLike, 'wid'> = {
  widgetType: PageWidgetType.Quiz,
  title: 'Quiz',
  css: '',
  quizId: '',
  itemDisplay: 'embed',
  showItemTitle: false,
};

export const QuizWidgetEditor: WidgetEditor = {
  icon: 'ph:question-bold',
  label: 'Quiz',
  component: PageWidgetQuizComponent,
  dataType: DataTypeContent.PageWidgetQuiz,
  widgetData: DEFAULT_WIDGET_QUIZ,
};
